export default "__VITE_ASSET__DSlqoKrp__"